import { IMessage } from '@mnz-core/models/message';
import * as appActions from '@mnz-store/actions/app.actions';
import { createReducer, on } from '@ngrx/store';
import { v1 as Guid } from 'uuid';

export const initialState: IAppState = {
  messages: [],
};

export interface IAppState {
  readonly messages: Array<IMessage>;
}

export const reducer = createReducer(
  initialState,
  on(appActions.addMessage, (state, { message }) => {
    return {
      ...state,
      messages: [
        {
          id: Guid(),
          created: new Date(),
          ...message,
        },
      ],
    };
  }),
  on(appActions.deleteMessage, (state, { id }) => {
    return { ...state, messages: Array(...state.messages.filter((error) => error.id !== id)) };
  }),
  on(appActions.clearMessages, (state) => {
    return { ...state, messages: [] };
  })
);
